/* Makes a horizontal row draggable by its own scrollbar.

   Binds to every `[data-wp-scroller]` wrapper that holds a `.wp-scroller` row,
   a `.wp-scroller__bar` track and a `.wp-scroller__thumb`. Shared by the theme
   tiles and the video testimonials.

   The row is already a native scroller, so it works by swipe, trackpad, wheel
   and keyboard without this. What a desktop mouse does not get from a native
   scroller is anything to grab, because the browser's own bar is hidden in CSS
   - it renders under the content and looks wrong there. Everything here is
   built at runtime so that without JavaScript the row is still a plain, usable
   scroller with no dead controls sitting on top of it. */
(function () {
  'use strict';

  function attach(wrap) {
    if (wrap.dataset.wpScrollerReady) return;
    var row = wrap.querySelector('.wp-scroller');
    var bar = wrap.querySelector('.wp-scroller__bar');
    var thumb = wrap.querySelector('.wp-scroller__thumb');
    if (!row || !bar || !thumb) return;
    wrap.dataset.wpScrollerReady = '1';

    var dragging = false;

    function maxScroll() {
      return row.scrollWidth - row.clientWidth;
    }

    function update() {
      var max = maxScroll();
      if (max <= 1) {
        wrap.classList.add('wp-scroller-wrap--fits');
        return;
      }
      wrap.classList.remove('wp-scroller-wrap--fits');

      var visible = row.clientWidth / row.scrollWidth;
      thumb.style.width = visible * 100 + '%';
      // The thumb travels the track's width less its own, which expressed as a
      // percentage of the thumb itself is (100 / visible) - 100.
      thumb.style.transform =
        'translateX(' + (row.scrollLeft / max) * (100 / visible - 100) + '%)';
    }

    /* Map a pointer position on the track to a scroll position. The thumb is
       centred on the pointer so the grab point does not jump, which means the
       usable track is shortened by the thumb's own width. */
    function scrollToPointer(clientX) {
      var rect = bar.getBoundingClientRect();
      var thumbW = thumb.getBoundingClientRect().width;
      var travel = rect.width - thumbW;
      if (travel <= 0) return;
      var x = clientX - rect.left - thumbW / 2;
      var ratio = Math.min(Math.max(x / travel, 0), 1);
      row.scrollLeft = ratio * maxScroll();
    }

    bar.addEventListener('pointerdown', function (e) {
      if (wrap.classList.contains('wp-scroller-wrap--fits')) return;
      dragging = true;
      bar.setPointerCapture(e.pointerId);
      wrap.classList.add('wp-scroller-wrap--dragging');
      // A press anywhere on the track jumps there, the way a scrollbar does.
      scrollToPointer(e.clientX);
      e.preventDefault();
    });

    bar.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      scrollToPointer(e.clientX);
      e.preventDefault();
    });

    function endDrag(e) {
      if (!dragging) return;
      dragging = false;
      wrap.classList.remove('wp-scroller-wrap--dragging');
      if (e && e.pointerId != null && bar.hasPointerCapture(e.pointerId)) {
        bar.releasePointerCapture(e.pointerId);
      }
    }

    bar.addEventListener('pointerup', endDrag);
    // A cancelled pointer - the browser taking the gesture, the tab hiding -
    // never fires pointerup, and without this the bar stays stuck to the cursor.
    bar.addEventListener('pointercancel', endDrag);

    row.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    // Media arrives after first paint and changes scrollWidth, so measure again.
    window.addEventListener('load', update);
    update();
  }

  function init() {
    document.querySelectorAll('[data-wp-scroller]').forEach(attach);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // The theme editor rebuilds a section's markup in place.
  document.addEventListener('shopify:section:load', init);
})();
